import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { KitSection } from './components/KitSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { LiveToast } from './components/LiveToast';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-900 font-sans text-white" data-id="element-0" data-mp="28t4kmbsl46ry">
      <Hero data-id="element-1" data-mp="23w4drynwuzzs" />
      <main data-id="element-2" data-mp="23ujksdh8vp41">
        <ProblemSection data-id="element-3" data-mp="23utb6267bya9" />
        <VolumesSection data-id="element-4" data-mp="23ti864kkyuk7" />
        <BonusesSection data-id="element-5" data-mp="3ik7jmqgv0tve" />
        <UrgencySection data-id="element-6" data-mp="3iiwfuqnezm4a" />
        <PricingSection data-id="element-7" data-mp="3ijpc2xoqyt86" />
        <KitSection data-id="element-8" data-mp="3mlja0y7k5j4n" />
        <TestimonialsSection data-id="element-9" data-mp="3ml13n8r6loj0" />
        <GuaranteeSection data-id="element-10" data-mp="3mk85gw6ag7ch" />
        <FaqSection data-id="element-11" data-mp="3mjg8bgx1m1k3" />
        <CostSection data-id="element-12" data-mp="3rc9co3oln7vn" />
        <FinalCta data-id="element-13" data-mp="3rbzmog3k10py" />
      </main>
      <Footer data-id="element-14" data-mp="3rcsw5otwe4bs" />
      <LiveToast data-id="element-15" data-mp="3recf5n6xuth9" />
    </div>;
}